import React from 'react';

const Header = ({ step }) => (
  <header className={`step${step}`}>
    <h1>{step < 5 ? 'Design test' : 'Thank you'}</h1>
    { step < 5 
      ? <p>Welcome to the <b>Design Test Task</b> for the position of Graphic Designer at Scetbird, you will have 3 task to complete in 2:00hrs, once the test starts, a timer will appear and you will only allow to send the files once the timer finish, Good Luck</p> 
      : <p>We are pretty sure you just send a Master piece, we will let you know as soon as possible about the position, thank you for your participation.</p>}
      { step < 5 && <a className="brief_link" target="_blank" href="https://docs.google.com/document/d/1hQOIAfQxkRW_X_zi41_8ML1tGCYdoPRYALbMA1QYumE/edit">Show me the Brief</a> }
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/containers/Header.js